import React, { useEffect, useState } from "react";
import Wrapper from "../../../components/Wrapper";
import { labApi } from "../../../services/labApi";

export default function CalculatorPage() {
  const [testCount, setTestCount] = useState("100");
  const [reagents, setReagents] = useState([]);
  const [selectedReagents, setSelectedReagents] = useState({});
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    labApi.getReagents().then((rows) => {
      setReagents(rows);
      setSelectedReagents(Object.fromEntries(rows.map((r) => [r.id, true])));
    }).catch(console.error);
  }, []);

  const runCalculation = async () => {
    try {
      setErrorMessage("");
      const reagent_ids = Object.entries(selectedReagents).filter(([, v]) => v).map(([id]) => id);
      if (!reagent_ids.length) {
        setResult(null);
        setErrorMessage("Select at least one reagent.");
        return;
      }
      const tc = Number(testCount || 0);
      if (!tc || tc < 1) {
        setResult(null);
        setErrorMessage("Enter a valid test count (1 or more).");
        return;
      }
      const data = await labApi.calculateRequirements({ test_count: tc, reagent_ids });
      setResult(data);
    } catch (error) {
      setResult(null);
      setErrorMessage(error?.response?.data?.message || "Unable to calculate requirements.");
    }
  };

  return (
    <Wrapper>
      <div className="space-y-6 pb-20 lg:pb-6">
        <h2 className="m-0 text-2xl font-bold text-slate-800">Chemical Calculator</h2>
        <div className="bg-white border rounded-xl p-4 space-y-3">
          <input value={testCount} onChange={(e) => setTestCount(e.target.value)} type="number" className="px-3 py-2 border rounded-lg w-full" />
          <div className="grid md:grid-cols-3 gap-2">
            {reagents.map((r) => (
              <label key={r.id} className="flex items-center gap-2 px-3 py-2 border rounded-lg">
                <input type="checkbox" checked={selectedReagents[r.id] || false} onChange={() => setSelectedReagents((prev) => ({ ...prev, [r.id]: !prev[r.id] }))} />
                <span>{r.name}</span>
              </label>
            ))}
          </div>
          <button onClick={runCalculation} className="px-4 py-2 bg-emerald-600 text-white rounded-lg">Calculate</button>
          {errorMessage ? (
            <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {errorMessage}
            </div>
          ) : null}
        </div>

        {result && (
          <div className="bg-white border rounded-xl p-4">
            <p className="font-semibold">Shortages: {result.shortage_count || 0}</p>
            <div className="space-y-2">
              {(result.chemicals || []).map((c) => (
                <div key={c.chemical_name} className="border rounded-lg px-3 py-2">
                  <p className="m-0 font-medium">{c.chemical_name}</p>
                  <p className="m-0 text-sm text-slate-600">
                    Needed: {c.total_needed} {c.unit}, Stock: {c.current_stock}, Deficit: {c.deficit}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
}
